export enum IntegrationAction {
  CONNECT = "connect",
  RECONNECT = "reconnect",
}
